import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import { ContextGraphListItem } from '@/types/context-graph-types';

export const getContextGraphs = async (): Promise<ContextGraphListItem[]> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<ContextGraphListItem[]>({
    url: `/context-graphs/${orgId}`,
    method: 'GET',
    target: 'platform',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }
  if (response.data && Array.isArray(response.data)) {
    return response.data;
  }
  throw new Error('Unexpected response format');
};
